import React from "react";
import { Card, Carousel, Container } from "react-bootstrap";

import imgArte1 from "../../../assets/images/arte1.jpg";
import imgArte2 from "../../../assets/images/arte2.jpg";
import imgArte3 from "../../../assets/images/arte3.jpg";
import imgArte4 from "../../../assets/images/arte4.jpg";
import MenuInteremedio from "./actividades/menuInteremedioActividades";

const images = [imgArte1, imgArte2, imgArte3, imgArte4];

function ActividadArte() {
  return (
    <div className="pb-5">
      {/* Encabezado */}
      <Card className="text-center">
        <Card.Body style={{ backgroundSize: "cover" }}>
          <Card.Text className="fw-bold fs-2">
            Música, Plástica y Teatro
          </Card.Text>
        </Card.Body>
      </Card>

      {/* Carrusel */}
      <Container className="my-4">
        <Carousel fade className="rounded shadow-lg overflow-hidden">
          {images.map((img, idx) => (
            <Carousel.Item key={idx}>
              <img
                className="d-block w-100"
                src={img}
                alt={`arte-${idx}`}
                style={{ height: "500px", objectFit: "cover" }}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>

      {/* Menú intermedio */}
      <MenuInteremedio />

      {/* Descripción del proyecto artístico */}
      <Container className="p-5 my-5 rounded shadow-lg" style={{ backgroundColor: "#294235" }}>
        <h2 className="text-white text-center mb-4 fw-bold" style={{ letterSpacing: "1px" }}>
          EL ARTE EN NUESTRO COLEGIO
        </h2>
        <p className="lead text-white fs-5" style={{ lineHeight: "1.8" }}>
          En el Colegio Santo Tomás, el arte es una herramienta esencial para el desarrollo emocional,
          cognitivo y social de nuestros estudiantes. A través de disciplinas como la música, la pintura,
          el dibujo y el teatro, fomentamos la creatividad, la expresión personal y la sensibilidad estética.
        </p>
        <p className="text-white fs-5" style={{ lineHeight: "1.8" }}>
          Creemos que el arte permite explorar nuevas formas de comunicación, favorece la autoestima y
          fortalece los lazos sociales. Nuestras clases promueven la libertad de expresión, el respeto por
          la diversidad y el trabajo en equipo.
        </p>
        <p className="text-white fs-5" style={{ lineHeight: "1.8" }}>
          Nuestro proyecto artístico busca despertar el pensamiento crítico, el disfrute por el proceso
          creativo y el interés por las distintas manifestaciones culturales. Acompañamos a cada alumno
          en su recorrido, respetando su ritmo, estilo e identidad.
        </p>
        <p className="text-white fs-5" style={{ lineHeight: "1.8" }}>
          El arte en Santo Tomás es un espacio para imaginar, transformar y construir un mundo más sensible
          y humano.
        </p>
      </Container>
    </div>
  );
}

export default ActividadArte;
